export const HOME= '/';
export const PROFILE = '/profile';
export const CREATENFTS = '/createnfts';
export const REVENUESTREAMS = '/revenuestreams';
export const NFTMINTDATA = '/nftmintdata';
export const LISTINGNFTS = '/listingnft';
export const DASHBOARD = '/dashboard';
export const WALLET = '/wallet';
export const MANAGECURRENCY='/currencyConversion'
